import { Tools } from "../../../Misc/tools.js";
import { SceneComponentConstants } from "../../../sceneComponent.js";
/**
 * Defines the Procedural Texture scene component responsible to manage any Procedural Texture
 * in a given scene.
 */
var ProceduralTextureSceneComponent = /** @class */ (function () {
    /**
     * Creates a new instance of the component for the given scene
     * @param scene Defines the scene to register the component in
     */
    function ProceduralTextureSceneComponent(scene) {
        /**
         * The component name helpful to identify the component in the list of scene components.
         */
        this.name = SceneComponentConstants.NAME_PROCEDURALTEXTURE;
        this.scene = scene;
        this.scene.proceduralTextures = new Array();
    }
    /**
     * Registers the component in a given scene
     */
    ProceduralTextureSceneComponent.prototype.register = function () {
        this.scene._beforeClearStage.registerStep(SceneComponentConstants.STEP_BEFORECLEAR_PROCEDURALTEXTURE, this, this._beforeClear);
    };
    /**
     * Rebuilds the elements related to this component in case of
     * context lost for instance.
     */
    ProceduralTextureSceneComponent.prototype.rebuild = function () {
        // Nothing to do here.
    };
    /**
     * Disposes the component and the associated resources.
     */
    ProceduralTextureSceneComponent.prototype.dispose = function () {
        // Nothing to do here.
    };
    ProceduralTextureSceneComponent.prototype._beforeClear = function () {
        if (this.scene.proceduralTexturesEnabled) {
            Tools.StartPerformanceCounter("Procedural textures", this.scene.proceduralTextures.length > 0);
            for (var proceduralIndex = 0; proceduralIndex < this.scene.proceduralTextures.length; proceduralIndex++) {
                var proceduralTexture = this.scene.proceduralTextures[proceduralIndex];
                if (proceduralTexture._shouldRender()) {
                    proceduralTexture.render();
                }
            }
            Tools.EndPerformanceCounter("Procedural textures", this.scene.proceduralTextures.length > 0);
        }
    };
    return ProceduralTextureSceneComponent;
}());
export { ProceduralTextureSceneComponent };
//# sourceMappingURL=proceduralTextureSceneComponent.js.map